module.exports = __webpack_public_path__ + "img/handshake.cfb08a7b.jpeg";